import { useState, useEffect } from "react";

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const linkColor = scrolled ? "text-midnight/60 hover:text-midnight" : "text-ivory/80 hover:text-ivory";
  const logoColor = scrolled ? "text-midnight" : "text-ivory";

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-midnight/10 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("hero")}
          className={`font-serif text-2xl font-black tracking-tight transition-colors duration-500 ${logoColor}`}
        >
          Kairós<span className="text-crimson">.</span> Learning
        </button>
        <nav className="hidden md:flex items-center gap-9">
          {[
            ["Qué es", "whatis"],
            ["Sistema", "sistema"],
            ["Productos", "productos"],
            ["Comparativo", "comparison"],
            ["FAQ", "faq"],
          ].map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollTo(id)}
              className={`font-sans text-sm transition-colors tracking-wide ${linkColor}`}
            >
              {label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta-button"
          onClick={() => scrollTo("registro")}
          className="bg-crimson text-ivory font-bold py-3 px-6 hover:bg-crimson-dark transition-all uppercase tracking-wider text-xs"
        >
          Aplicar ahora
        </button>
      </div>
    </header>
  );
}
